export const userStatusLabel = {
    Active: {
        state: 'ready',
        classname: '',
    },
    Invited: {
        state: 'progress',
        classname: 'user-invite-table-data',
    },
}
